import { Slider } from "@/components/ui/slider";
import { Switch } from "@/components/ui/switch";
import { HUD } from "./theme";

const SL = [["text", "Title size"], ["btn", "Button size"]];

// Sideways-phone sizing: auto-fit to the phone's height, plus owner fine-tuning
export const PhoneSizeEditor = ({ v, setV }) => {
  const set = (k, x) => setV({ ...v, phoneScale: { ...v.phoneScale, [k]: x } });
  return (
    <div className="flex flex-wrap items-center gap-x-6 gap-y-2 rounded-lg border border-cyan-400/15 p-3" data-testid="lettering-phone-size">
      <label className="flex items-center gap-2 text-xs text-gray-300">
        <Switch checked={v.phoneScale.auto} onCheckedChange={(on) => set("auto", on)} data-testid="lettering-phone-auto" />Auto-fit to the phone
      </label>
      {SL.map(([k, label]) => (
        <label key={k} className="flex items-center gap-3 text-[11px] text-gray-400 min-w-[220px]">
          <span className="w-28 whitespace-nowrap">{label} {Math.round(v.phoneScale[k] * 100)}%</span>
          <Slider value={[v.phoneScale[k]]} min={0.5} max={1.5} step={0.05} onValueChange={([x]) => set(k, x)} data-testid={`lettering-phone-${k}`} />
        </label>
      ))}
      <p className={`${HUD.label} w-full normal-case tracking-normal text-[11px] text-gray-500`}>Drag the title and buttons in this preview to place them on sideways phones only — desktop keeps its own spots. With Auto-fit on, sizes also shrink a little on shorter phones.</p>
    </div>
  );
};
